import React from 'react';
import Image from 'next/image';
import Config from '~/config';
import themeVariables from '~/shared/themeVariables';
const NewSurvey = ({ t }) => {
  return (
    <div>
      {Config.isIllustAC() && (
        <div className="container-survey-illust">
          {/* <Image
            unoptimized={true}
            layout="fill"
            className="img-background-survey"
            src={`${Config.staticPrefix}/static/images/survey/illust/survey-background.jpg`}
          /> */}
          <img
            className="img-background-survey"
            src={`${Config.staticPrefix}/static/images/survey/illust/survey-background.jpg`}
          />
          <a
            className="link-survey"
            target="_blank"
            href="https://docs.google.com/forms/d/e/1FAIpQLSez7-KzXB1dMHXdTx99CpeNEmTQCO8-2aZzrsFOzAXzLD5_qA/viewform"
            rel="noreferrer"
          >
            {t('survey_text')}
          </a>
        </div>
      )}
      {Config.isPhotoAC() && (
        <div className="container-survey-photo">
          {/* <Image
            unoptimized={true}
            layout="fill"
            className="img-background-survey"
            src={`${Config.staticPrefix}/static/images/survey/photo/survey-background.jpg`}
          /> */}
          <img
            className="img-background-survey"
            src={`${Config.staticPrefix}/static/images/survey/photo/survey-background.jpg`}
          />
          <a
            className="text-survey-photo"
            target="_blank"
            href="https://docs.google.com/forms/d/e/1FAIpQLSez7-KzXB1dMHXdTx99CpeNEmTQCO8-2aZzrsFOzAXzLD5_qA/viewform"
            rel="noreferrer"
          >
            {t('survey_text_photo')}
          </a>
        </div>
      )}
      <style>
        {`
            .container-survey-illust {
                position: relative;
                height: 90px;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
              }
  
              .link-survey {
                position: absolute;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 24px;
                color: #ffffff;
                font-weight: 500 !important;
                text-decoration: underline;
                text-align: center;
              }
              .img-background-survey{
                width: 100%;
                height: 100%;
              }
              .container-survey-photo {
                position: relative;
                width: 100%;
                height: 90px;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 54px;
                // background-image: url(${Config.staticPrefix}/static/images/survey/photo/survey-background.jpg);
                // background-repeat: no-repeat;
                // background-size: cover;
                // background-position: center;
              }
              .text-survey-photo {
                position: absolute;
                font-weight: 500;
                font-size: 24px;
                text-align: center;
                color: #ffffff;
                text-decoration: underline;
                text-align: center;
              }
              .link-survey:focus,
              .text-survey-photo:focus{
                color: #ffffff;
                text-decoration: underline;
              }
              .link-survey:hover,
              .text-survey-photo:hover{
                color: #ffffff;
                text-decoration: none;
              }
              @media (max-width: ${themeVariables.breakpoints.tabletS.maxWidth}px) {
                .container-survey-photo {
                  display: flex;
                  flex-direction: column;
                  gap: 12px;
                }
                .link-survey,
                .text-survey-photo {
                  font-weight: 400;
                  font-size: 16px;
                  text-align: center;
                  color: #ffffff;
                  text-decoration: none;
                }
                .container-survey-illust{
                  height: 40px;
                }
              }
             
              
              `}
      </style>
    </div>
  );
};

export default NewSurvey;
